import * as React from "react";
import {useEffect} from "react";
import "./styles.scss";

let timeOut: ReturnType<typeof setTimeout>;
let bgColor = "";

interface IProps {
    hideToast: () => void;
    toastDetails: {
        bgColor: string,
        msg: string,
    };
}

export default function Toast(props: IProps) {
    bgColor = props.toastDetails.bgColor !== "" ? props.toastDetails.bgColor : bgColor;
    useEffect(() => {
        if (props.toastDetails.msg !== "") {
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                props.hideToast();
            }, 3000);
        }
    }, [props.toastDetails.msg]);
    return (
        <div className={`custom-toast ${props.toastDetails.msg.trim() !== "" ? "ct-open p-2" : "ct-close"}`}
             style={{background: bgColor}}>
            {props.toastDetails.msg.slice(0, 46)} {props.toastDetails.msg.trim().length < 46 ? "" : "..."}
        </div>
    );
}
